var map = {
	"./brands/amaricanas-logo.svg": 33006,
	"./brands/americanas_delivery.svg": 43873,
	"./brands/logo-newtail-vtex-vertical.svg": 61109,
	"./brands/logo-newtail-vtex.svg": 27154,
	"./brands/magalu-logo.svg": 1569,
	"./brands/melimetric-logo.svg": 8941,
	"./brands/newtail-logo-simbolo.svg": 19972,
	"./brands/newtail-logo.svg": 56092,
	"./brands/rappi-logo.svg": 4480,
	"./photos/add-empty.svg": 84452,
	"./photos/chats-empty.svg": 94736,
	"./photos/clients-empty.svg": 35197,
	"./photos/clients-risk-empty.svg": 74495,
	"./photos/login.svg": 35770,
	"./photos/orders-empty.svg": 44220,
	"./photos/products-empty.svg": 50591,
	"./photos/reset-password.svg": 7670,
	"./photos/wpp-default-template.svg": 15917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63848;